import { api, post } from '../../service';
import { TABS_UNBIND, AUTH_PERMANENT, DEVICE_BIND } from '../../libs/enum';

const defaultForm = () => ({
    deviceIds: '',
    auth: AUTH_PERMANENT,
    channel: 0,
    expireTime: '',
    noFusionChannel: 0,
    appControl: 0,
    comment: '',
    touch: 0,
    isH5QrCode: 1,
    qrEnable: 0,
    scene: 1,
    memo: '',
});

const agentDevice = {
    namespaced: true,
    state: {
        dialog: {
            visible: false,
            type: DEVICE_BIND,
        },
        form: defaultForm(),
        search: {
            size: 10,
            page: 1,
            key: '',
            bind: TABS_UNBIND,
            agentId: 0,
        },
        total: 0,
        devices: [],
        selection: [],
        maxChannel: 0,
    },
    actions: {
        async getDevices({ commit, state }, data = {}) {
            const params = Object.assign({}, state.search, data);
            const res = await post(api.device.search, params);
            commit('changeDevices', res);
        },
        async bindDevice({ commit, dispatch, state }, data) {
            const params = {
                ...state.form,
                agentId: data,
                channel:
                    state.form.noFusionChannel == 1 ? 0 : state.form.channel,
                noFusionChannel:
                    state.form.noFusionChannel == 1
                        ? state.form.channel
                        : state.form.noFusionChannel,
                comment: state.form.comment,
            };
            await post(api.device.bind, params);
            commit('changeDialog', { visible: false });
            dispatch('getDevices');
        },
        async unbindDevice({ dispatch }, data) {
            await post(api.device.unbind, data);
            dispatch('getDevices');
        },
        async authDevice({ dispatch, commit, state }) {
            const params = {
                ...state.form,
                isAgent: 1,
                channel:
                    state.form.noFusionChannel == 1 ? 0 : state.form.channel,
                noFusionChannel:
                    state.form.noFusionChannel == 1
                        ? state.form.channel
                        : state.form.noFusionChannel,
                comment: state.form.comment,
            };
            await post(api.device.auth, params);
            commit('changeDialog', { visible: false });
            dispatch('getDevices');
        },
        changeDialog({ commit }, data) {
            commit('changeDialog', data);
        },
        changeForm({ commit }, data) {
            commit('changeForm', data);
        },
        changeSearch({ commit, dispatch }, data) {
            commit('changeSearch', data);
            dispatch('getDevices');
        },
        changeSelection({ commit }, data) {
            commit('changeSelection', data);
        },
        changeMaxChannel({ commit }, data) {
            commit('changeMaxChannel', data);
        },
    },
    mutations: {
        changeDevices(state, data) {
            const list = [...data.devices];
            list.forEach(item => {
                if (item.auth === AUTH_PERMANENT) {
                    const time = new Date();
                    let year = time.getFullYear();
                    let month = time.getMonth() + 1;
                    if (month === 12) {
                        year += 1;
                        month = '01';
                    } else {
                        if (month < 9) {
                            month = `0${month + 1}`;
                        } else if (month === 9) {
                            month = 10;
                        } else {
                            month = month + 1;
                        }
                    }
                    let day = time.getDate();
                    day = day < 10 ? `0${day}` : day;
                    const newTime = `${year}-${month}-${day} 00:00:00`;
                    item.expireTime = newTime;
                }
            });
            state.total = data.totalCount;
            state.devices = list;
        },
        changeDialog(state, data) {
            Object.assign(state.dialog, data);
            if (!data.visible) {
                state.form = defaultForm();
            }
        },
        changeForm(state, data) {
            Object.assign(state.form, data);
        },
        changeSearch(state, data) {
            Object.assign(state.search, data);
        },
        changeSelection(state, data) {
            state.selection = data;
        },
        changeMaxChannel(state, data) {
            state.maxChannel = data;
        },
    },
};

export default agentDevice;
